import { superAxios } from "./superAxios";


export enum ProductSaleStatusEmun {
  Launch = 2121010,    // 上架
  TakeDown = 2121020,   // 下架
  RecycleBin = 2121030  // 回收站
 
}




var OcelotService="OcelotService";
 export interface categoryData {
  id: string  
  parentId: number
  categeroyName: string
  categeroyId: number
  shopTypeStatus: number
  fullCategoryId: string

  fullCategoryName?: string
}


export const GetListBusinessCategory = async (params: any) => {
        
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/ProductSystem/GetBusinessCategory",
    params
  });
 
  return  res;
};
 
//产品列表
export const Productlist = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/ProductSystem/GetListESProductInfoForEs",
    params
  });
    
  return res;
};
//店铺分类
export const GetListShopRecommendHeads = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/ProductSystem/GetListShopRecommendHeads",
    params
  });
    
  return res;
};

//添加与更新购物车
export const CreateOrUpdateShoppingCart = async (params: any) => {
    var res = await (await superAxios.useWebAPI(OcelotService)).post({
        url: "app/ShoppingCart/CreateOrUpdateShoppingCart",
        params
    })
    return res;
}
 //获取购物车
 export const GetShoppingCart = async (params: any) => {
 
  const res = await (
    await superAxios.useWebAPI(OcelotService)
  ).getH({
    url: "app/ShoppingCart/GetShoppingCart",
    params
  });
    
  return res;
};
//删除购物车
 export const DeleteShoppingCart = async (params: any) => {
 
 // 1. 转成格式化的 JSON（带换行和缩进）
 
     var res = await (await superAxios.useWebAPI(OcelotService)).post({
             url: "app/ShoppingCart/DeleteShoppingCart",
             params
         })
     
    
  return res;
};